module.exports = __webpack_public_path__ + "static/media/project_planning.4a13b47b.svg";